import React, { useContext } from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTheme } from '@emotion/react';
import { InputAdornment } from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { FormattedMessage } from 'react-intl';
import { handleSubmit } from './Newsletter.utils';
import { useNewsletterForm, 
  //useSubscribeStatus 
} from './Newsletter.hooks';
import { LangContext } from 'store/lang/LangProvider';

const Newsletter = () => {
  const theme = useTheme();
  const language = useContext(LangContext);
  const { form, setFormValue, setFormError } = useNewsletterForm();
  //const { subscribeStatus, handleSubscribeStatus } = useSubscribeStatus();
  return (
    <Box bgcolor={'secondary.contrastText'}>
      <Box marginBottom={4}>
        <Typography
          fontWeight={700}
          variant={'h5'}
          align={'center'}
          gutterBottom
          color={theme.palette.primary.contrastText}
        >
          <FormattedMessage id={'newsletter.title'} />
        </Typography>
        <Typography
          component={'p'}
          color={theme.palette.primary.contrastText}
          align={'center'}
        >
          <FormattedMessage id={'newsletter.p'} />
        </Typography>
      </Box>
      <Box maxWidth={600} margin={'0 auto'}>
        <Box
          component={'form'}
          noValidate
          autoComplete="off"
          sx={{
            '& .MuiInputBase-input.MuiOutlinedInput-input': {
              bgcolor: 'secondary.contrastText',
            },
          }}
        >
          <Box
            display="flex"
            flexDirection={{ xs: 'row', md: 'row' }}
            alignItems={{ xs: 'center', md: 'center' }}
            justifyContent={{ xs: 'center' }}
          >
            <TextField
              flex={'2 1 auto'}
              label={<FormattedMessage id={'newsletter.placeholder'} />}
              variant="outlined"
              fullWidth
              height={44}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    bgcolor="secondary.contrastText"
                  >
                    <NotificationsNoneIcon
                      sx={{
                        color: 'primary.contrastText',
                        backgroundColor: 'secondary.contrastText',
                      }}
                    />
                  </InputAdornment>
                ),
              }}
              sx={{
                color: theme.palette.primary.contrastText,
                borderRadius: '0.3rem',
                maxWidth: 422,
              }}
              onChange={(e) =>
                setFormValue({ field: 'email', newValue: e.target.value })
              }
              error={form.email.error}
              helperText={form.email.error ? form.email.errorMessage : ''}
            />
            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{
                marginLeft: '1rem',
              }}
              onClick={handleSubmit({
                errorSetter: setFormError,
                email: form.email.value,
                language: language.value,
              })}
            >
              <FormattedMessage id={'newsletter.calltoaction'} />
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Newsletter;
